import { config } from '@app/config';
import { Chip } from '@mui/material';

/**
 * Dev-only chip that displays the fragment variant label, positioned at bottom-left of the card media.
 * Renders only when NODE_ENV is development and variant is non-null.
 */
export function VideoFragmentVariantChip({ variant }: { variant: string | null }) {
  if (!config.isNodeDev || !variant) {
    return null;
  }
  return (
    <Chip
      label={variant}
      size="small"
      variant="filled"
      color="primary"
      sx={{
        position: 'absolute',
        bottom: 8,
        left: 8,
        zIndex: 1,
      }}
    />
  );
}
